export const miscNewsComponent = {
  key: 'miscNewsComponent',
  name: 'Misc News Dept-Component',
  siteIdentifier: 'global',

  subscribeDescriptionLabel: `Subscribe to the latest news, promotions, & more from PetSafe®
brand.`,
  subscribeButton: 'Subscribe'
};
